var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"alertBanner",staticClass:"alert show",class:[
    {
      'alert-dismissible': _vm.isDismissible,
      'with-icon': _vm.hasIcon,
    },
    _vm.alert, _vm.alertAnimation
  ]},[(_vm.isDismissible)?_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":_vm.close}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),(_vm.hasIcon)?_c('i',{class:{'alert-icon': _vm.hasIcon}}):_vm._e(),_vm._v(" "),_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.alertMessage))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }